import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { useT } from '../i18n/index.ts';
import { EmptyState, buttonClass } from '../ui/index.ts';

/**
 * 404 page for routes not yet defined. A proper empty-state moment —
 * title, hint, and one action back to the dispatch desk (DESIGN.md §7:
 * empty states invite action).
 */
export function NotFound(): JSX.Element {
  const t = useT();
  return (
    <EmptyState
      testId="not-found"
      icon={<Compass aria-hidden="true" className="h-5 w-5" />}
      title={t('notfound.title')}
      hint={t('notfound.body_prefix')}
      action={
        <Link to="/" className={buttonClass('secondary')}>
          {t('notfound.back')}
        </Link>
      }
    />
  );
}
